var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-range-picker',{staticClass:"date-range-picker rounded-lg",attrs:{"format":"YYYY-MM-DD HH:mm:ss","time-title-format":"YYYY-MM-DD HH:mm:ss","type":"datetime","lang":{
      formatLocale: {
        months: [
          'Ocak',
          'Şubat',
          'Mart',
          'Nisan',
          'Mayıs',
          'Haziran',
          'Temmuz',
          'Ağustos',
          'Eylül',
          'Ekim',
          'Kasım',
          'Aralık',
        ],
        monthsShort: [
          'Oca',
          'Şub',
          'Mar',
          'Nis',
          'May',
          'Haz',
          'Tem',
          'Ağu',
          'Eyl',
          'Eki',
          'Kas',
          'Ara',
        ],
        weekdays: [
          'Pazar',
          'Pazartesi',
          'Salı',
          'Çarşamba',
          'Perşembe',
          'Cuma',
          'Cumartesi',
        ],
        weekdaysShort: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
        weekdaysMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
        firstDayOfWeek: 1,
        firstWeekContainsDate: 7,
      },
    }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }